import { cdnUrl as cdnUrlService } from '@projectfive/services';

export function cdnUrl(path: string | undefined) {
    return cdnUrlService(path, `${process.env.VUE_APP_CDNPATH}`);
}

export default cdnUrl;
